/* ai-tabs-panel.tsx generated by @compiled/babel-plugin v0.38.1 */
import _extends from "@babel/runtime/helpers/extends";
import "./ai-tabs-panel.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { forwardRef } from 'react';
import { cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { useTabPanel } from '@atlaskit/tabs';
import { QueryIntent } from '../../../constants';
var styles = {
  root: "_1reo15vq _18m915vq _n3td12x7 _19bvpxbi _u5f3pxbi _ca0qutpp",
  rootCollapsed: "_4t3i68cl _1nwp1n9w",
  rootCollapsedWithReadMore: "_1reo15vq _18m915vq _4t3iucft _1bto1l2s _o5721q9c _1nwp1n9w",
  rootExpanded: "_1tke1k53",
  explicitQuestionCollapsed: "_4t3i1ogy _1nwp1n9w",
  explicitQuestionCollapsedWithReadMore: "_4t3i1018 _1bto1l2s _o5721q9c _1nwp1n9w",
  explicitQuestionExpanded: "_1tke1q9m",
  fullWidth: "_1bsb1osq"
};
export var AITabsPanel = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    collapsed = _ref.collapsed,
    _ref$showReadMoreButt = _ref.showReadMoreButton,
    showReadMoreButton = _ref$showReadMoreButt === void 0 ? false : _ref$showReadMoreButt,
    xcss = _ref.xcss,
    queryIntent = _ref.queryIntent;
  var tabPanelAttributes = useTabPanel();
  return /*#__PURE__*/React.createElement(Box, _extends({}, tabPanelAttributes, {
    ref: ref,
    xcss: xcss !== null && xcss !== void 0 ? xcss :
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    cx(styles.root, queryIntent === QueryIntent.EXPLICIT_QUESTION ? collapsed ? showReadMoreButton ? styles.explicitQuestionCollapsedWithReadMore : styles.explicitQuestionCollapsed : styles.explicitQuestionExpanded : collapsed ? showReadMoreButton ? styles.rootCollapsedWithReadMore : styles.rootCollapsed : styles.rootExpanded)
  }), /*#__PURE__*/React.createElement(Box, {
    xcss: styles.fullWidth
  }, children));
});